import {
  PRESUPUESTADOR_VALIDATE_COSTO_PATENTAMIENTO_BEGIN,
  PRESUPUESTADOR_VALIDATE_COSTO_PATENTAMIENTO_SUCCESS,
  PRESUPUESTADOR_VALIDATE_COSTO_PATENTAMIENTO_FAILURE,
  PRESUPUESTADOR_VALIDATE_COSTO_PATENTAMIENTO_DISMISS_ERROR,
} from './constants'

export function validateCostoPatentamiento(costoPatentamiento) {
  return (dispatch) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: PRESUPUESTADOR_VALIDATE_COSTO_PATENTAMIENTO_BEGIN,
    })

    const DEFAULT_TIMEOUT = 2 * 100

    const promise = new Promise((resolve, reject) => {
      const doRequest =
        costoPatentamiento < 0
          ? new Promise((res) =>
              setTimeout(res, DEFAULT_TIMEOUT, {
                valid: false,
                reasons: 'porque no',
                value: 0,
              }),
            )
          : new Promise((res) =>
              setTimeout(res, DEFAULT_TIMEOUT, {
                valid: true,
                reasons: 'porque si',
                value: costoPatentamiento,
              }),
            )
      doRequest.then(
        (res) => {
          dispatch({
            type: PRESUPUESTADOR_VALIDATE_COSTO_PATENTAMIENTO_SUCCESS,
            data: {
              gastosDeEntrega: res.value,
              gastosDeEntregaModificados: true
            },
          })
          resolve(res)
        },
        (err) => {
          dispatch({
            type: PRESUPUESTADOR_VALIDATE_COSTO_PATENTAMIENTO_FAILURE,
            data: { error: err },
          })
          reject(err)
        },
      )
    })

    return promise
  }
}

export function dismissValidateCostoPatentamientoError() {
  return {
    type: PRESUPUESTADOR_VALIDATE_COSTO_PATENTAMIENTO_DISMISS_ERROR,
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case PRESUPUESTADOR_VALIDATE_COSTO_PATENTAMIENTO_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        validateCostoPatentamientoPending: true,
        validateCostoPatentamientoError: null,
      }

    case PRESUPUESTADOR_VALIDATE_COSTO_PATENTAMIENTO_SUCCESS:
      // The request is success
      return {
        ...state,
        validateCostoPatentamientoPending: false,
        validateCostoPatentamientoError: null,
        ...action.data,
      }

    case PRESUPUESTADOR_VALIDATE_COSTO_PATENTAMIENTO_FAILURE:
      // The request is failed
      return {
        ...state,
        validateCostoPatentamientoPending: false,
        validateCostoPatentamientoError: action.data.error,
      }

    case PRESUPUESTADOR_VALIDATE_COSTO_PATENTAMIENTO_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        validateCostoPatentamientoError: null,
      }

    default:
      return state
  }
}
